import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-view-order-modal',
    templateUrl: './view-order-modal.component.html',
    styles: [],
})
export class ViewOrderModalComponent implements OnInit {
    constructor(public activeModal: NgbActiveModal) {}

    order: any;

    ngOnInit(): void {}

    printReceipt() {
        document.getElementById('receipt-print-target-area').innerHTML = document.getElementById('receipt-print-area').innerHTML;
        window.print();
    }

    getDisacountValue(): number {
        const orderTotal = this.order.subTotal;
        const discount = this.order.discount / 100;
        const totalVal = orderTotal - orderTotal * discount;
        return orderTotal - totalVal;
    }

    copyWhatsApp() {
        var div = document.getElementById('whatsappOrderCopy');
        this.copyOrder(div.innerText);
    }

    copyOrder(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }
}
